<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.5524 4.0008C13.2473 3.6957 12.7527 3.6957 12.4476 4.00079L3.39618 13.0522C3.09108 13.3573 2.59642 13.3573 2.29132 13.0522C1.98623 12.7471 1.98623 12.2524 2.29132 11.9473L11.3427 2.89594C12.258 1.98065 13.742 1.98065 14.6573 2.89594L23.7087 11.9473C24.0138 12.2524 24.0138 12.7471 23.7087 13.0522C23.4036 13.3573 22.9089 13.3573 22.6038 13.0522L13.5524 4.0008Z"
                :fill="color" 
            />
            <path
                d="M13 5.65808L4.50103 14.157C4.47007 14.188 4.43847 14.2179 4.40625 14.2468V20.7029C4.40625 21.7816 5.28069 22.656 6.35938 22.656H9.875C10.3065 22.656 10.6562 22.3062 10.6562 21.8748V17.1873C10.6562 16.7558 11.006 16.406 11.4375 16.406H14.5625C14.994 16.406 15.3438 16.7558 15.3438 17.1873V21.8748C15.3438 22.3062 15.6935 22.656 16.125 22.656H19.6406C20.7193 22.656 21.5938 21.7816 21.5938 20.7029V14.2468C21.5615 14.2179 21.5299 14.188 21.499 14.157L13 5.65808Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgHome',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>